import React, { useEffect, useState } from "react";
import { Laptop, Smartphone, Tablet, Bot } from "lucide-react"; 
import { Pagination } from "../Pagination";
import { Badge } from "reactstrap";

const DataTables = ({ data }) => {
  console.log(data)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [ipGroups, setIpGroups] = useState({});
  const [expandedRow, setExpandedRow] = useState(null);

  // Detect device type
  const detectDeviceType = (userAgent) => {
    if (!userAgent)
      return { type: "Unknown", icon: <Laptop className="h-4 w-4" />, color: "gray" };
    if (/(android|iphone|ipod|mobile)/i.test(userAgent))
      return { type: "Mobile", icon: <Smartphone className="h-4 w-4" />, color: "purple" };
    if (/(tablet|ipad|kindle)/i.test(userAgent))
      return { type: "Tablet", icon: <Tablet className="h-4 w-4" />, color: "indigo" };
    if (/(bot|crawl|spider)/i.test(userAgent))
      return { type: "Bot", icon: <Bot className="h-4 w-4" />, color: "red" };
    return { type: "Desktop", icon: <Laptop className="h-4 w-4" />, color: "gray" };
  };

  // Copy IP to clipboard
  const copyToClipboard = (ip) => {
    navigator.clipboard.writeText(ip).then(() => {
      console.log("IP copied to clipboard:", ip);
    });
  };

  // Check if IP is private
  const isPrivateIP = (ip) =>
    ip.startsWith("192.168.") ||
    ip.startsWith("10.") ||
    ip.startsWith("172.16.") ||
    ip.startsWith("172.17.") ||
    ip.startsWith("172.18.") ||
    ip.startsWith("172.19.") ||
    ip.startsWith("172.2") ||
    ip === "127.0.0.1";

  // Get geo info for IP
  const getGeoInfo = async (ip) => {
    const cacheKey = `geo_${ip}`;
    const cached = localStorage.getItem(cacheKey);
    if (cached) return JSON.parse(cached);

    try {
      const response = await fetch(`http://ip-api.com/json/${ip}`);
      if (response.ok) {
        const data = await response.json();
        if (data.status === "success") {
          const geoInfo = {
            country: data.country || "Unknown",
            city: data.city || "Unknown",
          };
          localStorage.setItem(cacheKey, JSON.stringify(geoInfo));
          return geoInfo;
        }
      }
    } catch (err) {
      console.error("Failed to fetch geo info:", err);
    }

    return { country: "Unknown", city: "Unknown" };
  };

  // Group data by IP and enrich with geo info
  useEffect(() => {
    const processData = async () => {
      const grouped = {};

      // Group visits by IP
      data.forEach((visit) => {
        if (!visit.ip || visit.ip === "UNKNOWN") return;
        if (!grouped[visit.ip]) grouped[visit.ip] = [];
        grouped[visit.ip].push(visit);
      });

      // Sort visits per IP (latest first)
      for (const ip in grouped) {
        grouped[ip].sort((a, b) => new Date(b.time) - new Date(a.time));

        // Attach geo info to the IP
        if (!isPrivateIP(ip)) {
          const geoInfo = await getGeoInfo(ip);
          grouped[ip].geo = geoInfo;
        } else {
          grouped[ip].geo = { country: "Private Network", city: "" };
        }
      }

      setIpGroups(grouped);
    };

    processData();
  }, [data]);

  console.log("neha", ipGroups, data)
  // Pagination
  const uniqueIpList = Object.entries(ipGroups)
    .map(([ip, visits]) => ({ ip, visits }))
    .sort((a, b) => new Date(b.visits[0].time) - new Date(a.visits[0].time)); // Sort by latest visit

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = uniqueIpList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(uniqueIpList.length / itemsPerPage);

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
console.log(currentItems)
  return (
    <div
      className="bg-white text-left overflow-hidden sm:rounded-lg mt-4"
      style={{ boxShadow: "-1px 0px 4px 0px #c8c8c8" }}
    >
      <div className="px-4 py-4 sm:px-6 border-b border-gray-200">
        <h3 className="text-xl leading-6 font-medium text-gray-900">
          Recent Visitor Activity
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Detailed log of visitor interactions with your website.
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-center divide-y divide-gray-200">
          <thead className="border-b bg-[#f6f6f6]">
<tr className="text-gray-700 text-md">
  <th scope="col" className="px-6 py-3 w-[80px]">View</th>
  <th scope="col" className="px-6 py-3 w-[150px]">IP Address</th>
  <th scope="col" className="px-6 py-3 w-[200px]">Location</th>
  <th scope="col" className="px-6 py-3 w-[180px]">Visit Time</th>
  <th scope="col" className="px-6 py-3 w-[350px]">Form Submitted</th>
  <th scope="col" className="px-6 py-3 w-[300px]">Device Info</th>
  <th scope="col" className="px-6 py-3 w-[100px]">Referrer</th>
</tr>

          </thead>
          <tbody className="divide-y divide-gray-200">
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-6 py-4 text-center text-sm text-gray-500">
                  No visitor data found
                </td>
              </tr>
            ) : (
              currentItems.map(({ ip, visits }) => {
                const latestVisit = visits[0]; // latest activity
                const deviceInfo = detectDeviceType(latestVisit.user_agent);
                const isExpanded = expandedRow === ip;

                return (
                  <React.Fragment key={ip}>
                    <tr
                      className="cursor-pointer hover:bg-gray-50"
                      onClick={() => setExpandedRow(isExpanded ? null : ip)}
                    >
                      <td className="px-6 py-3 text-left text-lg font-medium">
                        {isExpanded ? "-" : "+"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="text-sm font-medium text-gray-900">{ip}</div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              copyToClipboard(ip);
                            }}
                            className="ml-2 text-gray-400 hover:text-gray-600"
                            title="Copy IP"
                          >
                            <i className="fas fa-copy"></i>
                          </button>
                        </div>
                      </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center gap-2">
                    {ipGroups[ip]?.geo?.country && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                        {ipGroups[ip].geo.country}
                    </span>
                    )}
                    {ipGroups[ip]?.geo?.city && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                        {ipGroups[ip].geo.city}
                    </span>
                    )}
                </div>
                </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{latestVisit.time}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {latestVisit.form_submitted === "Yes" ? (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            Yes
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                            No
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center space-x-2">
                          <span className={`text-${deviceInfo.color}-600`}>
                            {deviceInfo.icon}
                          </span>
                          <span className="text-sm font-medium text-gray-900">
                            {deviceInfo.type}
                          </span>
                          {latestVisit.user_agent && (
                            <span
                              className="ml-2 text-gray-400 hover:text-gray-600 cursor-pointer"
                              title={latestVisit.user_agent}
                            >
                              <i className="fas fa-info-circle"></i>
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        <div className="truncate max-w-xs" title={latestVisit.referrer}>
                          {latestVisit.referrer || "Direct"}
                        </div>
                      </td>
                    </tr>

                    {isExpanded && (
                <tr>
                    <td colSpan="7" className="bg-gray-50 px-6 py-4">
                    <div className="space-y-4 max-h-64 overflow-y-auto">
                        {visits.map((visit, idx) => (
                        <div
                            key={idx}
                            className="visit-item bg-white p-3 rounded-lg shadow-sm border-l-2 border-[#3b82f6]"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div>
                                <p className="text-sm text-gray-500">Time</p>
                                <p className="text-sm text-gray-900">{visit.time}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Form Submitted</p>
                                <p className="text-sm text-gray-900">
                                {visit.form_submitted === "Yes" ? (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                    Yes
                                    </span>
                                ) : (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800">
                                    No
                                    </span>
                                )}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-500">Referrer</p>
                                <p className="text-sm text-gray-900 truncate">
                                {visit.referrer || "N/A"}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-500">Device</p>
                                <p
                                className="text-sm text-gray-900 truncate"
                                title={visit.user_agent}
                                >
                                {detectDeviceType(visit.user_agent).type}
                                </p>
                            </div>
                            </div>
                        </div>
                        ))}
                    </div>
                    </td>
                </tr>
                )}

                  </React.Fragment>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={itemsPerPage}
          totalItems={uniqueIpList.length}
          onPrevPage={handlePrevPage}
          onNextPage={handleNextPage}
        />
      )}
    </div>
  );
};

export default DataTables;
